export const CIVIL_JUDGEMENT_TYPES = {
  ACCOUNTING: 'ACCOUNTING',
  MEDICAL: 'MEDICAL',
  MECHANICAL: 'MECHANICAL',
};
